import { compareParticipantByLineupOrder } from '@collector/shared-ui-domain'

import { PlayersConfig } from '../../configuration'

export const playersConfig: PlayersConfig = {
  compareFn: compareParticipantByLineupOrder,
}
